import { getDefaultFilter } from '~features/dashboard-filters';

import type { FindApplicationsRequestParams } from '~entities/application';

import type {
  ColumnActionOptions,
  ColumnSizingOptions,
  DashboardTableState,
} from '~shared/ui/dashboard-table';

import { ColumnId } from './columns';
import { filtersToParams } from './search-params-converters';

export const defaultState: DashboardTableState<ColumnId> = {
  sort: { orderBy: ColumnId.DATE, direction: 'desc' },
  pagination: { page: 0, rowsPerPage: 10 },
};

export const defaultSearchParams: FindApplicationsRequestParams = {
  page: 0,
  perPage: 10,
  sort: { order: 'DESC', key: 'applicationTimestampUTC' },
  filter: filtersToParams(getDefaultFilter()),
};

export const colSizingOptions: Record<ColumnId, ColumnSizingOptions> = {
  [ColumnId.AGREEMENT_ID]: { minWidth: 120, width: '15%' },
  [ColumnId.STATUS]: { minWidth: 90 },
  [ColumnId.DATE]: { minWidth: 106, width: '14%' },
  [ColumnId.POS]: { minWidth: 190, width: '28%' },
  [ColumnId.SALE_AMOUNT]: { minWidth: 80 },
  [ColumnId.DOWN_PAYMENT]: { minWidth: 80 },
  [ColumnId.FINANCED_AMOUNT]: { minWidth: 80 },
};

export const colActionOptions: Record<ColumnId, ColumnActionOptions> = {
  [ColumnId.AGREEMENT_ID]: { isSortable: true },
  [ColumnId.STATUS]: { isSortable: true },
  [ColumnId.DATE]: { isSortable: true },
  [ColumnId.POS]: { isSortable: false },
  [ColumnId.SALE_AMOUNT]: { isSortable: true },
  [ColumnId.DOWN_PAYMENT]: { isSortable: true },
  [ColumnId.FINANCED_AMOUNT]: { isSortable: true },
};
